import React from 'react';
import { RoutingStore } from '../../stores/RoutingStore';
import { FedopsLoggerStore } from '../../stores/FedopsLoggerStore';
import { TemplatesStore } from '../../stores/TemplatesStore';
import { CategoriesStore } from '../../stores/CategoriesStore';
import { ConfigStore } from '../../stores/ConfigStore';
import { UiLoggerStore } from '../../stores/UiLoggerStore';
import { Category } from '../../../../types/api';
import { injectV2 } from '../../injectV2';
import { WithTranslations, withTranslations } from '../../../utils/withTranslations';
import { paginationDataHooks } from './Pagination.dataHooks';
import s from './Pagination.scss';

interface PaginationProps extends WithTranslations {
  fedopsLoggerStore: FedopsLoggerStore;
  routingStore: RoutingStore;
  templatesStore: TemplatesStore;
  categoriesStore: CategoriesStore;
  uiLoggerStore: UiLoggerStore;
  dataHook?: string;
  configStore: ConfigStore;
}

class PaginationCmp extends React.Component<PaginationProps> {
  private loadMore = () => {
    const { nextPageLocation, nextPage, replace } = this.props.routingStore;
    if (nextPageLocation) {
      this.props.fedopsLoggerStore.startPaginationInteraction();
      this.props.uiLoggerStore.logPagination(nextPage);
      replace(nextPageLocation);
    }
  };

  private getPageTitle(): string {
    let title: string = '';

    const { t, configStore } = this.props;
    const { matchedRoute } = this.props.routingStore;

    if (matchedRoute.routeName === 'home') {
      title = t('templates.allWebsite');
    } else if (matchedRoute.routeName === 'search') {
      title = `‘${matchedRoute.params.criteria}’`;
    } else if (matchedRoute.routeName === 'subCategory' || matchedRoute.routeName === 'category') {
      let category: Category | undefined;
      if (matchedRoute.routeName === 'subCategory') {
        category = this.props.categoriesStore.getCategoryBySlug(matchedRoute.params.subCategorySlug);
      } else {
        category = this.props.categoriesStore.getCategoryBySlug(matchedRoute.params.categorySlug);
      }

      title = category ? configStore.getCategoryTitle(category, t) : '';
    }

    return title;
  }

  public render() {
    const { t, dataHook } = this.props;
    const pageTitle = this.getPageTitle();
    const itemsTotal = this.props.templatesStore.itemsTotal;
    const templatesLength = this.props.templatesStore.loadedItemsCount;
    const showViewMore = this.props.templatesStore.hasMore;

    return (
      <div className={s.loadMore} data-hook={dataHook}>
        <div data-hook={paginationDataHooks.text()} className={s.text} aria-live="polite" aria-atomic="true">
          {t('templates.loadMore.txt', { pageTitle, templatesLength, total: itemsTotal })}
        </div>
        {showViewMore && (
          <button
            className={s.button}
            onClick={this.loadMore}
            disabled={this.props.templatesStore.isLoadingTemplates}
            data-hook={paginationDataHooks.button()}
          >
            <span className={s.buttonText} tabIndex={-1}>
              {t('templates.loadMore')}
            </span>
          </button>
        )}
      </div>
    );
  }
}

export const Pagination = withTranslations(
  injectV2(
    'routingStore',
    'templatesStore',
    'categoriesStore',
    'uiLoggerStore',
    'fedopsLoggerStore',
    'configStore',
  )(PaginationCmp),
);
